import { styled } from 'stitches.config'

export const AwesomerRoot = styled('div', {
  display: 'flex',
  width: '100%',
  position: 'relative',
  flexDirection: 'column',
  alignItems: 'center',

  // let's try alignitems flex-end

  '& .desktop-only': {
    display: 'none',
  },
  '& .mobile-only': {
    display: 'block',
  },

  '@bp2': {
    '& .desktop-only': {
      display: 'block',
    },
    '& .mobile-only': {
      display: 'none',
    },
  },
})

export const BackgroundImage = styled('div', {
  width: '100%',
  maxWidth: '1920px',
  lineHeight: 0,
})

export const BackgroundImageMobile = styled('div', {
  position: 'relative',
  width: '100%',
  maxWidth: '500px',
  height: '478px',
})

export const ContentWrapper = styled('div', {
  position: 'absolute',
  top: 0,
  zIndex: 1,
  left: 0,
  right: 0,
  display: 'flex',
  textAlign: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '$4',
  height: '478px',

  '@bp2': {
    top: '15%',
    gap: '$6',
    height: 'auto',
  },

  '@bp3': {
    top: '17%',
  },
})
